module.exports = __webpack_public_path__ + "static/img/Riley-Mcgree.3a4475a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Riley-Mcgree.jpg
// module id = 9zMU
// module chunks = 0